import { Tabs as AntdTabs, type TabsProps, Flex } from 'antd';
import { PageHeader } from 'components';
import type { VFC } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { ModelLibraryTab } from './const';
import { ManufacturersListRouter } from './routes/manufacturers/Router';
import { ModelsListRouter } from './routes/models/Router';
import { ModulesListRouter } from './routes/modules/Router';

const { TabPane } = AntdTabs;

export const Page: VFC = () => {
  const history = useHistory();
  const { tab = ModelLibraryTab.Manufacturer } = useParams<{ tab: ModelLibraryTab }>();

  const handleTabChange: TabsProps['onChange'] = (activeTab: ModelLibraryTab) => {
    history.push(`/reseller-data/model-library/${activeTab}`);
  };

  return (
    <Flex vertical gap={8}>
      <PageHeader ghost={false} title="Model library" />

      <AntdTabs
        activeKey={tab}
        size="small"
        tabBarStyle={{ paddingLeft: 24, backgroundColor: 'white' }}
        onChange={handleTabChange}
      >
        <TabPane key={ModelLibraryTab.Manufacturer} tab="Manufacturer">
          <ManufacturersListRouter />
        </TabPane>

        <TabPane key={ModelLibraryTab.Model} tab="Meter model">
          <ModelsListRouter />
        </TabPane>

        <TabPane key={ModelLibraryTab.Module} tab="Meter module">
          <ModulesListRouter />
        </TabPane>
      </AntdTabs>
    </Flex>
  );
};
